<template>
  <tr class="h-20 text-xs font-normal">
    <!-- TODO сделать константу -->
    <th align="left" class="font-normal montserrat">Интересанты в CRM:</th>
    <th class="font-normal">{{ interestedPartyLength }}</th>
  </tr>
</template>

<script>
export default {
  name: 'PlatformsTableInterests',
  props: {
    interestedPartyLength: Number,
  },
}
</script>
